import ugeskriftet from "../../assets/brands/ugeskriftet.png";
import innovationsfonden from "../../assets/brands/innovationsfonden-beskåret.png";
import novonordisk from "../../assets/brands/novo-nordisk-beskåret.png";
import { Link } from "react-router-dom";

export default function Brands() {
  return (
    <div className="container mx-auto">
      <div className="grid pt-16 pb-24 grid-cols-1 md:grid-cols-2 gap-12">
        <div className="flex items-center md:items-end justify-center">
          <span className="text-doctio-dark mr-4 font-light">Beskrevet i:</span>
          <div className="flex align-end">
            <a
              className="h-[28px] inline-block"
              href="https://ugeskriftet.dk/nyhed/frasedoktorerne"
            >
              <img src={ugeskriftet} width={235} alt="Ugeskriftet logo" />
            </a>
          </div>
        </div>

        <div className="flex items-center md:items-end mt-3 md:mt-0 justify-center">
          <span className="text-doctio-dark mr-4 font-light">Støtte af:</span>

          <div className="flex items-center md:items-end flex-col md:flex-row justify-center">
            <div className="flex align-end md:mr-12">
              <Link
                className="h-[30.33px] inline-block"
                to="/disclaimers/innovationsfonden"
              >
                <img
                  src={innovationsfonden}
                  width={200}
                  className="mt-1.5"
                  alt="Innovationasfonden logo"
                />
              </Link>
            </div>
            <div className="mt-4 flex align-end md:mt-0">
              <Link
                className="h-[71px] inline-block"
                to="/disclaimers/novo-nordisk"
              >
                <img src={novonordisk} width={100} alt="Novo Nordisk logo" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
